import { Text, Table, Icon } from '@quintoandar-tokko/jopijs';
import styles from '../dashboardTables.module.scss';
import ContactCell from '../components/ContactCell';
import AgentBranchCell from '../components/AgentBranchCell';
import AssignmentCell from '../components/AssignmentCell';
import Trans from '@/components/shared/Trans';
import translations from '@/components/Dashboard/Dashboard.trans.json';
import OriginCell from '../components/OriginCell';

export default function NewContactsTableRow({ contact }) {
  const {
    id,
    origin,
    days_of_follow_up,
    name,
    qualification,
    close_date,
    image,
    agent,
    assignment_date,
    lead_status,
    email,
    cellphone,
  } = contact;

  return (
    <Table.RowDefault id={id} variant="secondary">
      <Table.RowItemDefault
        variant="secondary"
        className={styles.tableBodyCell}
      >
        <ContactCell
          id={id}
          image={image}
          name={name}
          email={email}
          cellphone={cellphone}
          agent={agent}
          leadStatus={lead_status}
          relativeSelector="#new-contacts-modal"
          modal="newContacts"
        />
      </Table.RowItemDefault>

      <Table.RowItemDefault
        variant="secondary"
        className={styles.tableBodyCell}
      >
        <OriginCell origin={origin} />
      </Table.RowItemDefault>

      <Table.RowItemDefault
        variant="secondary"
        className={styles.tableBodyCell}
      >
        <Text variant="body.fontSize13">
          {days_of_follow_up ? (
            Trans(translations, 'CountFollowUpDays', days_of_follow_up)
          ) : (
            <Icon icon="icon-mostrarmenos" className={styles.emptyDataIcon} />
          )}
        </Text>
      </Table.RowItemDefault>

      <Table.RowItemDefault
        variant="secondary"
        className={styles.tableBodyCell}
      >
        <AgentBranchCell
          agentId={agent?.id}
          agentName={agent?.name}
          branchName={agent?.branch_name}
          image={agent?.profile_picture}
          relativeSelector="#new-contacts-modal"
          withBoldTitle
          withBranch
          modal="newContacts"
        />
      </Table.RowItemDefault>

      <Table.RowItemDefault
        variant="secondary"
        className={styles.tableBodyCell}
      >
        <AssignmentCell
          assignmentDate={assignment_date}
          closeDate={close_date}
          qualification={qualification}
        />
      </Table.RowItemDefault>
    </Table.RowDefault>
  );
}
